import axios, { AxiosResponse } from "axios";
import { CONFIG } from "../../config";
import { AxiosError, StatusCodes } from "./Configurations";
import { StorageConstants } from "../storage/storageConstants";
import { clearAuthStorage } from "../storage/AuthStorage";
import { Navigate } from "react-router-dom";

const BASE_URL = CONFIG.baseApiUrl;

// Create an Axios instance with default configuration
export const axiosBridge = axios.create({
  baseURL: BASE_URL, // Replace with your API base URL
  timeout: 15000, // Timeout in milliseconds
  headers: {
    "Content-Type": "application/json",
    "x-region": "Asia/Kolkata",
    "X-PACKAGE-NAME": "starnex-admin-app",
  },
});

let controller;
let id;

// Add a request interceptor
axiosBridge.interceptors.request.use(
  async (config) => {
    // You can modify the request configuration here
    // For example, add authentication headers or perform transformations
    const token = await localStorage.getItem(StorageConstants.LOGIN_TOKEN);
    // const token =
    //   "eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkIjoxNzQwMTIwMDgwMTQ2LCJhdXRob3JpdHkiOlt7ImF1dGhvcml0eSI6IjQ3In0seyJhdXRob3JpdHkiOiIxMTgifSx7ImF1dGhvcml0eSI6IjExOCJ9LHsiYXV0aG9yaXR5IjoiMjAifSx7ImF1dGhvcml0eSI6IjIxIn0seyJhdXRob3JpdHkiOiIyMiJ9LHsiYXV0aG9yaXR5IjoiMjMifSx7ImF1dGhvcml0eSI6IjI0In0seyJhdXRob3JpdHkiOiIyNSJ9LHsiYXV0aG9yaXR5IjoiMjYifSx7ImF1dGhvcml0eSI6IjI3In0seyJhdXRob3JpdHkiOiIyOCJ9LHsiYXV0aG9yaXR5IjoiMjkifSx7ImF1dGhvcml0eSI6IjMwIn0seyJhdXRob3JpdHkiOiIzMSJ9LHsiYXV0aG9yaXR5IjoiMzIifSx7ImF1dGhvcml0eSI6IjMzIn0seyJhdXRob3JpdHkiOiIzNCJ9LHsiYXV0aG9yaXR5IjoiMzUifSx7ImF1dGhvcml0eSI6IjM2In0seyJhdXRob3JpdHkiOiIzNyJ9LHsiYXV0aG9yaXR5IjoiMzgifSx7ImF1dGhvcml0eSI6IjM5In0seyJhdXRob3JpdHkiOiI0MCJ9LHsiYXV0aG9yaXR5IjoiNDEifSx7ImF1dGhvcml0eSI6IjQyIn0seyJhdXRob3JpdHkiOiI0MyJ9LHsiYXV0aG9yaXR5IjoiNDQifSx7ImF1dGhvcml0eSI6IjQ1In0seyJhdXRob3JpdHkiOiI0NiJ9LHsiYXV0aG9yaXR5IjoiNzQifSx7ImF1dGhvcml0eSI6IjEwOSJ9LHsiYXV0aG9yaXR5IjoiMiJ9LHsiYXV0aG9yaXR5IjoiMyJ9LHsiYXV0aG9yaXR5IjoiMTkifSx7ImF1dGhvcml0eSI6IjQ4In0seyJhdXRob3JpdHkiOiI0OSJ9LHsiYXV0aG9yaXR5IjoiNTAifSx7ImF1dGhvcml0eSI6IjUxIn0seyJhdXRob3JpdHkiOiI1MiJ9LHsiYXV0aG9yaXR5IjoiNTMifSx7ImF1dGhvcml0eSI6IjU0In0seyJhdXRob3JpdHkiOiI1NSJ9LHsiYXV0aG9yaXR5IjoiNTYifSx7ImF1dGhvcml0eSI6IjU3In0seyJhdXRob3JpdHkiOiI1OCJ9LHsiYXV0aG9yaXR5IjoiNTkifSx7ImF1dGhvcml0eSI6IjYwIn0seyJhdXRob3JpdHkiOiI2MSJ9LHsiYXV0aG9yaXR5IjoiNjIifSx7ImF1dGhvcml0eSI6IjYzIn0seyJhdXRob3JpdHkiOiI2NCJ9LHsiYXV0aG9yaXR5IjoiNjUifSx7ImF1dGhvcml0eSI6IjY2In0seyJhdXRob3JpdHkiOiI2NyJ9LHsiYXV0aG9yaXR5IjoiNjgifSx7ImF1dGhvcml0eSI6IjY5In0seyJhdXRob3JpdHkiOiI3MCJ9LHsiYXV0aG9yaXR5IjoiNzEifSx7ImF1dGhvcml0eSI6IjEwNSJ9LHsiYXV0aG9yaXR5IjoiMTA3In0seyJhdXRob3JpdHkiOiIxMDgifSx7ImF1dGhvcml0eSI6IjExNiJ9LHsiYXV0aG9yaXR5IjoiMTE2In0seyJhdXRob3JpdHkiOiIxMTgifSx7ImF1dGhvcml0eSI6IjExOCJ9LHsiYXV0aG9yaXR5IjoiUk9MRV81In0seyJhdXRob3JpdHkiOiJST0xFXzEifSx7ImF1dGhvcml0eSI6IlJPTEVfNCJ9XSwiZW1haWxJZCI6bnVsbCwibW9iaWxlTm8iOiI5ODAyNDgyMzcxIiwidHlwZSI6IlJFQ1JVSVRFUiIsImV4cCI6MTc3MTY1NjA4MCwidXNlcmlkIjoiVUlEMTcwNDc5OTI4Nzc4MyIsInVzZXJuYW1lIjoiQXV0byJ9.cRelAzG6m8fZ0j7d-TNmFU_cyyQWxYuxWHInHNJlEYkv2-O11aPQ2Z9785LXkEpEz76dn1XHvYOo_N4g5ddGpA";

    const signupToken = "";

    if (token) {
      config.headers["Authorization"] = `Bearer_${token}`;
    } else if (signupToken) {
      config.headers["Authorization"] = `Bearer_${signupToken}`;
    }

    if (controller?.signal?.aborted !== false)
      controller = new AbortController();
    const signal = controller.signal;

    return { ...config, signal };
  },
  (error) => {
    // Handle request errors
    console.log("Axios error req:", error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosBridge.interceptors.response.use(
  (response) => {
    // You can modify the response here
    // For example, handle global success scenarios
    return response;
  },
  (error) => {
    // Handle response errors
    console.log("Axios error:", error?.response?.data ?? error);

    const response = error?.response?.data;

    if (!response) {
      return Promise.reject(AxiosError);
    }

    if (
      response?.code === StatusCodes.NOT_ACCEPTABLE ||
      response?.code === StatusCodes.AUTH_FAILED ||
      response?.code === StatusCodes.NO_DATA_FOUND
    ) {
      return { data: response };
    }

    if (response?.code === StatusCodes.INVALID_ACCESS) {
      clearAuthStorage();
      sessionStorage.clear();
      // Navigate({ to: "/login", replace: true });
    }

    return Promise.reject(response);
  }
);
